function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Preview");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.299502418
}, React.createElement("g", {
  id: 3.4,
  transform: "translate(-931.000000, -629.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "gallery_icon",
  transform: "translate(931.000000, 629.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M8.89833333,12.4953333 C10.7073333,12.4953333 12.1736667,11.029 12.1736667,9.22 C12.1736667,7.411 10.7073333,5.94466667 8.89833333,5.94466667 C7.08933333,5.94466667 5.623,7.411 5.623,9.22 C5.623,11.029 7.08933333,12.4953333 8.89833333,12.4953333 L8.89833333,12.4953333 Z M25.645,15.205 C25.1783333,14.8726667 24.506,14.8433333 24.007,15.292 L20.8033333,18.1743333 C19.5693333,19.2703333 17.6656667,19.093 16.6553333,17.788 L15.9433333,16.8686667 C15.0626667,15.731 13.4963333,15.448 12.2853333,16.136 C12.1536667,16.2106667 12.025,16.2936667 11.903,16.3916667 L4.77733333,22.2093333 C4.16533333,22.709 3.81033333,23.457 3.81033333,24.247 L3.81033333,25.2896667 C3.81033333,25.7733333 4.20233333,26.1653333 4.68566667,26.1653333 L25.4176667,26.1653333 C25.8443333,26.1653333 26.19,25.8193333 26.19,25.393 L26.19,16.2643333 C26.19,15.8033333 25.9656667,15.4333333 25.645,15.205 L25.645,15.205 Z M28,26.728 C28,27.4293333 27.4296667,28 26.7283333,28 L3.272,28 C2.57066667,28 2,27.4293333 2,26.728 L2,3.27166667 C2,2.57033333 2.57066667,2 3.272,2 L26.7283333,2 C27.4296667,2 28,2.57033333 28,3.27166667 L28,26.728 Z M26.7283333,0 L3.272,0 C1.465,0 0,1.46466667 0,3.27166667 L0,26.728 C0,28.535 1.465,30 3.272,30 L26.7283333,30 C28.5353333,30 30,28.535 30,26.728 L30,3.27166667 C30,1.46466667 28.5353333,0 26.7283333,0 L26.7283333,0 Z",
  id: "Shape"
})))));

var SvgGalleryIcon = function SvgGalleryIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGalleryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gallery_icon.55996c25.svg";
export { ForwardRef as ReactComponent };